import guidedSearchStore from '../../../../guided/guided-search-store';

export const redirectionBuilder = (country: string, language: string): string => {
    const gsTerm = guidedSearchStore.get('gsTerm');

    if (gsTerm) {
      const parsedUrl = new URL(window.location.href);
      const newUrl = new URL(parsedUrl.origin);

      newUrl.hostname = parsedUrl.hostname;
      newUrl.pathname = `/${country}/${language}/search/`;
      newUrl.searchParams.set('q', gsTerm);

      return newUrl.toString();
    }
};

export const redirectionHandler = (
  anchorElement: HTMLAnchorElement,
  newLocation: string,
) => {
    anchorElement.href = newLocation;
    anchorElement.click();
    anchorElement.remove();
    window.URL.revokeObjectURL(newLocation);
};

export const bannerInteractionHandler = async (
  country: string,
  language: string,
  callback: () => void,
) => {
    const anchorElement = document.createElement('a');
    const newLocation = redirectionBuilder(country, language);

    await callback();

    if (newLocation) {
      redirectionHandler(anchorElement, newLocation);
    }
};
